import React from 'react';
import {
  VStack,
  Box,
  Text,
  IconButton,
  HStack,
  useColorModeValue,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
} from '@chakra-ui/react';
import { FiMoreVertical, FiTrash2 } from 'react-icons/fi';
import { format } from 'date-fns';
import { useAI } from '../../../contexts/AIContext';

interface ConversationListProps {
  onSelect: (conversationId: string) => void;
}

const ConversationList: React.FC<ConversationListProps> = ({ onSelect }) => {
  const { conversations, currentConversation, deleteConversation } = useAI();
  const bgColor = useColorModeValue('white', 'gray.800');
  const hoverBg = useColorModeValue('gray.50', 'gray.700');
  const activeBg = useColorModeValue('blue.50', 'blue.900');
  const borderColor = useColorModeValue('gray.200', 'gray.700');

  return (
    <Box height="100%" display="flex" flexDirection="column" overflow="hidden">
      <VStack 
        spacing={0} 
        align="stretch" 
        flex={1} 
        overflowY="auto" 
        maxH="calc(100vh - 100px)"
        css={{
          '&::-webkit-scrollbar': {
            width: '4px',
          },
          '&::-webkit-scrollbar-track': {
            width: '6px',
            background: useColorModeValue('gray.100', 'gray.800'),
          },
          '&::-webkit-scrollbar-thumb': {
            background: useColorModeValue('gray.300', 'gray.600'),
            borderRadius: '24px',
          },
        }}
      >
        {conversations.map((conversation) => (
          <Box
            key={conversation.id}
            p={4}
            cursor="pointer"
            bg={currentConversation?.id === conversation.id ? activeBg : bgColor}
            _hover={{ bg: currentConversation?.id === conversation.id ? activeBg : hoverBg }}
            borderBottom="1px solid"
            borderColor={borderColor}
            onClick={() => onSelect(conversation.id)}
          >
            <HStack justify="space-between" align="start">
              <Box flex={1}>
                <Text
                  fontWeight="medium"
                  noOfLines={2}
                  fontSize="sm"
                >
                  {conversation.title}
                </Text>
                <Text
                  fontSize="xs"
                  color="gray.500"
                  mt={1}
                >
                  {format(new Date(conversation.updated_at), 'MMM d, yyyy h:mm a')}
                </Text>
              </Box>
              <Menu>
                <MenuButton
                  as={IconButton}
                  icon={<FiMoreVertical />}
                  variant="ghost"
                  size="sm"
                  onClick={(e) => e.stopPropagation()}
                />
                <MenuList>
                  <MenuItem
                    icon={<FiTrash2 />}
                    onClick={(e) => {
                      e.stopPropagation();
                      deleteConversation(conversation.id);
                    }}
                  >
                    Delete
                  </MenuItem>
                </MenuList>
              </Menu>
            </HStack>
          </Box>
        ))}
      </VStack>
    </Box>
  );
};

export default ConversationList; 